
import { Component, signal } from '@angular/core';
import { LanguageService } from '../../services/language'; 
import { TranslatePipe } from '@ngx-translate/core';
@Component({
  imports: [TranslatePipe],
  selector: 'app-about',
  styleUrl: './about.component.css',
  templateUrl: './about.component.html',
})
export class AboutComponent {



constructor(public languageService: LanguageService){}

  toggleLanguage(): void {
    const current = this.languageService.getLanguage();

    this.languageService.changeLanguage(
      current === 'ar' ? 'en' : 'ar'
    );
  }


}
